import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import {
  UnsupportedViewer,
  ImgViewer,
  PDFViewer,
  // DocxViewer,
  // XlsxViewer,
} from './drivers';

function FileViewer({ url, mimeType }) {
  const Driver = useMemo(
    () => {
      switch (mimeType) {
        case 'application/pdf':
          return PDFViewer;
        case 'image/jpeg':
          return ImgViewer;
          // case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          //   return XlsxViewer;
          // case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          //   return DocxViewer;
        default:
          return UnsupportedViewer;
      }
    },
    [mimeType],
  );
  // console.log(mimeType, fileURL);
  return (
    <Driver mimeType={mimeType} url={url} />
  );
}

FileViewer.propTypes = {
  mimeType: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default FileViewer;
